import { Component, OnInit } from '@angular/core';
import { SiteDashboardService } from '../site-dashboard.service';

@Component({
	selector: 'app-truckviews',
	templateUrl: './truckviews.component.html',
	styleUrls: ['./truckviews.component.css']
})
export class TruckviewsComponent implements OnInit {

	constructor(
		private siteDashboardService: SiteDashboardService,
	) { }

	ngOnInit() {
		this.siteDashboardService.setActiveTab('trucks');
	}
}